<template>
    <span>
        <template v-if="disabled">
            <slot />
        </template>
        <v-tooltip
            v-else
            :top="top"
            :bottom="!top"
            :left="left"
            transition="slide-y-transition"
            :color="color"
            :max-width="maxWidth"
            :nudge-top="nudgeTop"
            :nudge-right="nudgeRight"
            :nudge-bottom="nudgeBottom"
            :nudge-left="nudgeLeft"
        >
            <template #activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                    <slot />
                </span>
            </template>
            <slot v-if="findSlot('display')" name="display" />
            <template v-else-if="Array.isArray(value)">
                <span v-for="(item, index) in value" :key="index">
                    {{ item }}
                    <br />
                </span>
            </template>
            <template v-else>
                {{ value }}
            </template>
        </v-tooltip>
    </span>
</template>

<script>
export default {
    name: 'AppTooltip',
    props: {
        value: {
            type: [String, Number, Array],
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'primaryText'
        },
        maxWidth: {
            type: String,
            default: '30rem'
        },
        top: {
            type: Boolean,
            default: false
        },
        left: {
            type: Boolean,
            default: false
        },
        nudgeTop: {
            type: Number,
            default: null
        },
        nudgeRight: {
            type: Number,
            default: null
        },
        nudgeBottom: {
            type: Number,
            default: null
        },
        nudgeLeft: {
            type: Number,
            default: null
        }
    }
};
</script>
